import React, {Fragment, useMemo} from "react";
import {StatusCount} from "../../services/ApiModels/BackgroundTasks";
import ProjectsService from "../../services/ProjectsService";
import {useFetchWithLoadingSmart} from "../../hooks/useFetch";
import BackgroundTasksService from "../../services/BackgroundTasksService";

interface StatusSource {
    fetch(): Promise<StatusCount[]>;
}

export function ProjectBackgroundTasks(props: any) {
    const curProjectId = props.match.params.projectId;
    const source = useMemo(() => new class implements StatusSource {
        fetch(): Promise<StatusCount[]> {
            return ProjectsService.backgroundStatus(curProjectId);
        }
    }, [curProjectId]);
    return (
        <BackgroundTasksInner statusSource={source}/>
    );
}

export function GlobalBackgroundTasks() {
    const source = useMemo(() => new class implements StatusSource {
        fetch(): Promise<StatusCount[]> {
            return BackgroundTasksService.globalStatus();
        }
    }, []);
    return (
        <BackgroundTasksInner statusSource={source}/>
    );
}

function BackgroundTasksInner({statusSource}: {statusSource: StatusSource}) {
    const status = useFetchWithLoadingSmart(
        () => statusSource.fetch(),
        [statusSource]
    )
    if (status.status == "loading") {
        return (
            <>loading...</>
        );
    }
    if (status.status == "error") {
        return (
            <>failed to load...</>
        );
    }
    const items = status.data;
    const total = items.reduce((acc, x) => acc + x.count, 0);
    return (
        <>
            {items.map(x => (
                <Fragment key={x.status}>{x.status}: {x.count}<br/></Fragment>
            ))}
            <Fragment>Total: {total}<br/></Fragment>
        </>
    );
}
